'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dLogin$002dPage$002dView$0024$0024anon$002421 from "./presto.-Login-Page-View$$anon$21.js";
import * as $j_presto$002e$002dLogin$002dPage$002dView$0024$0024anon$00247 from "./presto.-Login-Page-View$$anon$7.js";
import * as $j_presto$002etypes$0024$002dSingle$002dApp$002dToken$0024 from "./presto.types$-Single-App-Token$.js";
var $p;
/** @constructor */
function $c_Lpresto_LoginPageView$$anon$6() {
  this.b67 = null;
  this.b5Z = null;
  this.b60 = false;
  this.b68 = null;
  this.b69 = false;
  this.b6c = null;
  this.b65 = null;
  this.b66 = false;
  this.b61 = null;
  this.b62 = false;
  this.b63 = null;
  this.b64 = false;
  this.b6a = false;
  this.b6b = false;
  this.b67 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.b6c = "SingleAppToken";
}
export { $c_Lpresto_LoginPageView$$anon$6 as $c_Lpresto_LoginPageView$$anon$6 };
$p = $c_Lpresto_LoginPageView$$anon$6.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_LoginPageView$$anon$6;
/** @constructor */
function $h_Lpresto_LoginPageView$$anon$6() {
}
export { $h_Lpresto_LoginPageView$$anon$6 as $h_Lpresto_LoginPageView$$anon$6 };
$h_Lpresto_LoginPageView$$anon$6.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.I = (function() {
  return this.b67;
});
$p.M = (function() {
  if ((!this.b60)) {
    this.b5Z = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.b60 = true;
  }
  return this.b5Z;
});
$p.O = (function() {
  if ((!this.b69)) {
    this.b68 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.b69 = true;
  }
  return this.b68;
});
$p.E = (function() {
  return this.b6c;
});
$p.t = (function() {
  if ((!this.b66)) {
    this.b65 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("created", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("expires", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("user", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$())));
    this.b66 = true;
  }
  return this.b65;
});
$p.N = (function() {
  if ((!this.b62)) {
    this.b61 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().Gg(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Decoder$OptionDecoder($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().Gg())), ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(new $j_presto$002e$002dLogin$002dPage$002dView$0024$0024anon$00247.$c_Lpresto_LoginPageView$$anon$7(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()))));
    this.b62 = true;
  }
  return this.b61;
});
$p.Q = (function() {
  if ((!this.b64)) {
    this.b63 = new $j_presto$002e$002dLogin$002dPage$002dView$0024$0024anon$002421.$c_Lpresto_LoginPageView$$anon$21();
    this.b64 = true;
  }
  return this.b63;
});
$p.v = (function() {
  if ((!this.b6b)) {
    this.b6a = false;
    this.b6b = true;
  }
  return this.b6a;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee134) => ((p) => \u03b4scrutinee134.acZ(p)))($j_presto$002etypes$0024$002dSingle$002dApp$002dToken$0024.$m_Lpresto_types$SingleAppToken$())));
});
var $d_Lpresto_LoginPageView$$anon$6 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_LoginPageView$$anon$6, "presto.LoginPageView$$anon$6", ({
  Mt: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_LoginPageView$$anon$6 as $d_Lpresto_LoginPageView$$anon$6 };
//# sourceMappingURL=presto.-Login-Page-View$$anon$6.js.map
